import {
  getCurrentPublicToken,
  getSilentAccessToken,
} from "auth/components/authentication";
import axios from "axios";
import { env } from "env";
import {
  ApiError,
  ForbiddenResultError,
  UnauthorizedResultError,
  isProblemDetails,
} from "./apiError";

// const scope = [
//   "api://rpaconnect.io/b782e2e8-9682-4898-b211-a304714f4f6b/access_as_user",
// ];

const buildResponseError = (err: any) => {
  if (err?.response?.status === 404) {
    return new Error(
      "There may be a problem with the backend. Resource not found."
    );
  } else if (err?.response.status === 403) {
    return new ForbiddenResultError();
  } else if (err?.response.status === 401) {
    return new UnauthorizedResultError();
  } else if (err?.response.status === 400) {
    let error = err.response?.data;

    return error.detail
      ? new Error(error.detail)
      : error.title
      ? new Error(error.title)
      : new Error("One or more validation errors occurred.");
  } else if (err.message === "Network Error") {
    return new Error(
      "Cannot call RPA Connect due to network error, please check your network connection status and try again"
    );
  } else {
    let funcErrorMsg = err.message;
    if (err.response?.data?.error) {
      funcErrorMsg += ": " + err.response.data.error;
    }
    return new Error(funcErrorMsg);
  }
};

export const baseUrl = env.REACT_APP_API_ROOT_URL || "/api/";
const httpClient = axios.create({
  baseURL: baseUrl,
});
httpClient.defaults.headers.common["Content-Type"] = "application/json";
httpClient.defaults.headers.common["Accept"] = "application/json";

httpClient.interceptors.request.use(async (options) => {
  if (env.NODE_ENV === "test") return;
  const publicToken = getCurrentPublicToken();
  if (publicToken) {
    //if public token exists, authenticate with it
    options.params = { ...options.params, sharedformtoken: publicToken };
  } else {
    //if no public token, use user credentials
    const accessToken = await getSilentAccessToken();

    options.headers = {
      ...options.headers,
      authorization: `Bearer ${accessToken}`,
    };
  }

  return options;
});

httpClient.interceptors.response.use(undefined, (error) => {
  var processedError = isProblemDetails(error)
    ? new ApiError(error)
    : buildResponseError(error);
  return Promise.reject(processedError);
});

export default httpClient;
